import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export const useStyle = makeStyles<NextTheme>((theme) =>
  createStyles({
    labelContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(2.5),
    },
    label: {
      fontWeight: 600,
      fontSize: 12,
      color: Colors.textBlack,
      lineHeight: '15px',
      marginBottom: theme.spacing(1.25),
    },
  }));
